import { TrimCardStatusEnum } from "../../Enum/wfx.enum"

export class TrimCards {
    id: number
    styleData: string
    seasonData: string
    submitDate: string
    createdAt: string
    dropDown: string
    techPack: string
    filePath: string
    fileName: string;
    originalname: string;
    status: TrimCardStatusEnum
    combinedProductPlusColor: {
        combinedFabricColorHeaders: MeasurementDataReq[];
        combinedLabelColorHeaders: MeasurementDataReq[];
        combinedPackingColorHeaders: MeasurementDataReq[];
    }
    constructor(
        id: number,
        styleData: string,
        seasonData: string,
        submitDate: string,
        createdAt: string,
        dropDown: string,
        techPack: string,
        filePath: string,
        fileName: string,
        originalname: string,
        status: TrimCardStatusEnum,
        combinedProductPlusColor: {
            combinedFabricColorHeaders: MeasurementDataReq[];
            combinedLabelColorHeaders: MeasurementDataReq[];
            combinedPackingColorHeaders: MeasurementDataReq[];
        }
    ) {
        this.id = id
        this.styleData = styleData
        this.seasonData = seasonData
        this.submitDate = submitDate
        this.createdAt = createdAt
        this.dropDown = dropDown
        this.techPack = techPack
        this.status = status
        this.combinedProductPlusColor = combinedProductPlusColor
        this.filePath = filePath
        this.fileName = fileName
        this.originalname = originalname
    }
}



export class MeasurementDataReq {
    id?: number;
    styleId?: number;
    measurement?: string;
    constructor(
        id: number,
        styleId: number,
        measurement: string,
    ) {
        this.id = id;
        this.styleId = styleId;
        this.measurement = measurement;
    }

}

